import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

const AVATAR_KEY = 'avatarUrl';
const DEFAULT_AVATAR = '/assets/images/user-profile.png';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private profileImage = new BehaviorSubject<string>(
    localStorage.getItem(AVATAR_KEY) || DEFAULT_AVATAR
  );

  // consumers subscribe to this
  profileImage$ = this.profileImage.asObservable().pipe(distinctUntilChanged());

  setImage(url: string) {
    this.profileImage.next(url);
    localStorage.removeItem(AVATAR_KEY);
    localStorage.setItem(AVATAR_KEY, url);
  }

  clearImage() {
    localStorage.removeItem(AVATAR_KEY);
    this.profileImage.next(DEFAULT_AVATAR);
  }

  getImage(): string {
    return this.profileImage.getValue();
  }

   constructor() { }
}
